
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Navimumbaitofivejyotilinga() {



const cardData = {
  keyword: "Navi Mumbai to 5 Jyotirlinga Darshan Cab",
  heading: "Skyline Cabs: Navi Mumbai to 5 Jyotirlinga Darshan Cab",
  headingDescription: "Skyline Cabs offers dedicated Navi Mumbai to 5 Jyotirlinga Darshan Cab service for devotees seeking a spiritually fulfilling pilgrimage across Maharashtra. The sacred 5 Jyotirlingas typically include Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath. Our experienced drivers are familiar with temple routes, rural highways, and pilgrimage sequencing to ensure a smooth and organized yatra. Whether you require a structured multi-day tour package or flexible temple-wise darshan travel, we provide clean, air-conditioned vehicles with transparent pricing and professional coordination. Travel peacefully and complete your Jyotirlinga Yatra comfortably with Skyline Cabs.",

  top: "Top 5 Jyotirlinga Temples to Visit from Navi Mumbai",

  topPlaces: [
    {
      title: "Bhimashankar Jyotirlinga",
      description: "Bhimashankar Temple, located in the Sahyadri hills, is one of the most revered Jyotirlingas in Maharashtra. Surrounded by dense forest and scenic mountain landscapes, it offers both spiritual depth and natural beauty. Devotees traveling via Navi Mumbai to 5 Jyotirlinga Darshan Cab often begin their journey here. Early morning darshan provides a peaceful experience before crowds gather. The road journey through ghat sections requires experienced driving, which Skyline Cabs ensures for safety and comfort."
    },
    {
      title: "Trimbakeshwar Jyotirlinga",
      description: "Trimbakeshwar Temple near Nashik is known for its unique three-faced Shiva lingam representing Brahma, Vishnu, and Mahesh. Pilgrims booking 5 Jyotirlinga Darshan Cab from Navi Mumbai frequently visit during Shravan month for special rituals. The temple architecture reflects ancient stone craftsmanship. Our drivers ensure smooth travel across Nashik highways."
    },
    {
      title: "Grishneshwar Jyotirlinga",
      description: "Located near Ellora Caves in Aurangabad, Grishneshwar Jyotirlinga is the last of the 12 Jyotirlingas in India. The temple’s red stone architecture and peaceful ambiance create a divine atmosphere. Devotees choosing Maharashtra 5 Jyotirlinga Darshan Cab often combine this visit with Ellora sightseeing."
    },
    {
      title: "Aundha Nagnath Jyotirlinga",
      description: "Aundha Nagnath Temple is believed to be one of the oldest Jyotirlingas in India. The temple’s intricate carvings and historic structure attract pilgrims throughout the year. Navi Mumbai 5 Jyotirlinga Yatra Cab ensures safe long-distance connectivity."
    },
    {
      title: "Parli Vaijnath Jyotirlinga",
      description: "Parli Vaijnath Temple symbolizes healing and spiritual strength. Devotees believe worship here grants good health and prosperity. Skyline Cabs provides comfortable multi-day temple travel packages for this sacred destination."
    }
  ],

  services: [
    {
      name: "Navi Mumbai to 5 Jyotirlinga Darshan Cab",
      description: "Skyline Cabs provides Navi Mumbai to 5 Jyotirlinga Darshan Cab service designed for multi-day spiritual travel covering major Jyotirlinga temples across Maharashtra. Our experienced chauffeurs understand pilgrimage sequencing and temple timings to ensure organized darshan planning. Vehicles are air-conditioned, spacious, and suitable for long-distance travel with senior-friendly seating comfort. Flexible itinerary customization allows devotees to plan temple visits according to their schedule. Transparent pricing and safe highway driving make this service ideal for family pilgrimage travel."
    },
    {
      name: "5 Jyotirlinga Darshan Cab from Navi Mumbai",
      description: "5 Jyotirlinga Darshan Cab from Navi Mumbai includes complete temple route coordination with structured multi-day travel packages. Skyline Cabs ensures safe long-distance driving and comfortable accommodation coordination upon request."
    },
    {
      name: "Navi Mumbai 5 Jyotirlinga Yatra Cab",
      description: "Navi Mumbai 5 Jyotirlinga Yatra Cab provides reliable pilgrimage travel with experienced drivers familiar with temple roads and rural connectivity."
    },
    {
      name: "5 Jyotirlinga Tour Package Navi Mumbai by Cab",
      description: "5 Jyotirlinga Tour Package Navi Mumbai by Cab includes full itinerary planning, temple sequencing, and flexible travel duration."
    },
    {
      name: "Navi Mumbai to Jyotirlinga Darshan Taxi",
      description: "Navi Mumbai to Jyotirlinga Darshan Taxi ensures smooth temple travel with professional drivers and comfortable vehicles."
    },
    {
      name: "5 Jyotirlinga Darshan Yatra Cab",
      description: "5 Jyotirlinga Darshan Yatra Cab offers structured pilgrimage experience with route expertise."
    },
    {
      name: "Jyotirlinga Darshan Cab Service Navi Mumbai",
      description: "Jyotirlinga Darshan Cab Service Navi Mumbai provides clean vehicles and safe highway travel."
    },
    {
      name: "Maharashtra 5 Jyotirlinga Darshan Cab",
      description: "Maharashtra 5 Jyotirlinga Darshan Cab ensures organized temple visits across the state."
    },
    {
      name: "Jyotirlinga Tour Cab from Navi Mumbai",
      description: "Jyotirlinga Tour Cab from Navi Mumbai offers flexible multi-day spiritual travel packages."
    }
  ],

  tableData: [
    ["Navi Mumbai to 5 Jyotirlinga Darshan Cab", "5 Jyotirlinga Darshan Cab from Navi Mumbai"],
    ["Navi Mumbai 5 Jyotirlinga Yatra Cab", "5 Jyotirlinga Tour Package Navi Mumbai by Cab"],
    ["Navi Mumbai to Jyotirlinga Darshan Taxi", "5 Jyotirlinga Darshan Yatra Cab"],
    ["Jyotirlinga Darshan Cab Service Navi Mumbai", "Maharashtra 5 Jyotirlinga Darshan Cab"],
    ["Jyotirlinga Tour Cab from Navi Mumbai", ""]
  ],

  whychoose: [
    {
      WhyChooseheading: "Temple Route Expertise",
      WhyChoosedescription: "Drivers experienced with Jyotirlinga temple routes ensure organized and safe pilgrimage travel."
    },
    {
      WhyChooseheading: "Comfortable Long-Distance Vehicles",
      WhyChoosedescription: "Air-conditioned and spacious cars ideal for multi-day temple visits."
    },
    {
      WhyChooseheading: "Flexible Multi-Day Packages",
      WhyChoosedescription: "Customizable itinerary covering all five Jyotirlinga temples."
    },
    {
      WhyChooseheading: "Transparent Pricing",
      WhyChoosedescription: "Clear fare structure without hidden costs."
    },
    {
      WhyChooseheading: "Safe Highway Travel",
      WhyChoosedescription: "Professional driving standards for rural and ghat roads."
    },
    {
      WhyChooseheading: "Senior-Friendly Travel",
      WhyChoosedescription: "Comfortable seating and planned rest stops for elderly devotees."
    },
    {
      WhyChooseheading: "24x7 Booking Support",
      WhyChoosedescription: "Round-the-clock assistance for pilgrimage planning."
    },
    {
      WhyChooseheading: "Customer-Focused Service",
      WhyChoosedescription: "Dedicated support team ensures smooth spiritual journey."
    }
  ]
}


const faqData = [
    {
        id: 1,
        question: 'How can I book Navi Mumbai to 5 Jyotirlinga Darshan Cab with Skyline Cabs?',
        answer:
            'Booking Navi Mumbai to 5 Jyotirlinga Darshan Cab with Skyline Cabs is easy and convenient. Visit our website or mobile app, select Navi Mumbai as your pickup location, choose the 5 Jyotirlinga Darshan package, select your preferred vehicle, and confirm instantly. You will receive complete booking confirmation along with driver and trip details for a smooth pilgrimage journey.',
    },
    {
        id: 2,
        question: 'Which 5 Jyotirlingas are covered in the Navi Mumbai to 5 Jyotirlinga Darshan Cab package?',
        answer:
            'Our Navi Mumbai to 5 Jyotirlinga Darshan Cab package typically covers Trimbakeshwar, Bhimashankar, Grishneshwar, Parli Vaijnath, and Aundha Nagnath Jyotirlingas. The route can be customized based on your travel preference and temple visit sequence. We ensure a comfortable and well-managed spiritual journey across all destinations.',
    },
    {
        id: 3,
        question: 'How many days are required for Navi Mumbai to 5 Jyotirlinga Darshan Cab trip?',
        answer:
            'The Navi Mumbai to 5 Jyotirlinga Darshan Cab trip usually requires 3 to 4 days depending on your itinerary and temple visit duration. Skyline Cabs helps you plan the most efficient route so that you can complete your pilgrimage comfortably without rushing.',
    },
    {
        id: 4,
        question: 'What vehicles are available for Navi Mumbai to 5 Jyotirlinga Darshan Cab?',
        answer:
            'We offer Swift Dzire, Ertiga, Innova Crysta, and premium SUVs for Navi Mumbai to 5 Jyotirlinga Darshan Cab service. For families and group travel, spacious vehicles with ample luggage capacity are recommended to ensure maximum comfort during long-distance travel.',
    },
    {
        id: 5,
        question: 'Is the fare for Navi Mumbai to 5 Jyotirlinga Darshan Cab fixed?',
        answer:
            'Yes, Skyline Cabs provides transparent and fixed pricing for Navi Mumbai to 5 Jyotirlinga Darshan Cab service. The fare includes driver allowance and applicable charges. There are no hidden costs, and complete fare details are shared before booking confirmation.',
    },
    {
        id: 6,
        question: 'Can I customize my Navi Mumbai to 5 Jyotirlinga Darshan itinerary?',
        answer:
            'Yes, our Navi Mumbai to 5 Jyotirlinga Darshan Cab service is fully customizable. You can adjust temple visit order, overnight stay locations, and travel schedule according to your convenience. Our team helps you plan a comfortable and spiritually fulfilling journey.',
    },
    {
        id: 7,
        question: 'Is online payment available for Navi Mumbai to 5 Jyotirlinga Cab booking?',
        answer:
            'Yes, Skyline Cabs supports secure online payments including UPI, debit cards, credit cards, and net banking. Once payment is completed, you receive instant confirmation with full trip and driver details.',
    },
    {
        id: 8,
        question: 'Is Navi Mumbai to 5 Jyotirlinga Darshan Cab suitable for senior citizens?',
        answer:
            'Absolutely. Our Navi Mumbai to 5 Jyotirlinga Darshan Cab service is ideal for senior citizens and families. We provide comfortable seating, smooth suspension vehicles, experienced drivers, and flexible rest stops to ensure a relaxed pilgrimage experience.',
    },
    {
        id: 9,
        question: 'Is the Navi Mumbai to 5 Jyotirlinga Darshan Cab service available throughout the year?',
        answer:
            'Yes, Skyline Cabs offers Navi Mumbai to 5 Jyotirlinga Darshan Cab service year-round. Whether you are traveling during festivals, weekends, or regular days, we ensure reliable, safe, and punctual service.',
    },
    {
        id: 10,
        question: 'Why choose Skyline Cabs for Navi Mumbai to 5 Jyotirlinga Darshan Cab?',
        answer:
            'Skyline Cabs is trusted for Navi Mumbai to 5 Jyotirlinga Darshan Cab service because of our professional chauffeurs, comfortable and sanitized vehicles, transparent pricing, punctual travel management, and 24x7 customer support. We focus on delivering a peaceful, safe, and well-organized pilgrimage journey for every devotee.',
    },
];

const someReviews = [
    {
        name: "Mr. Suresh Kulkarni",
        rating: 5,
        review: "Booked Navi Mumbai to 5 Jyotirlinga Darshan Cab with Skyline Cabs for family pilgrimage. The itinerary was well planned, the car was comfortable, and the driver was very cooperative. Excellent and smooth spiritual journey!"
    },
    {
        name: "Mrs. Madhavi Patil",
        rating: 4,
        review: "Very reliable Navi Mumbai to 5 Jyotirlinga Darshan Cab service. Transparent pricing, safe driving, and comfortable vehicle. Skyline Cabs made our pilgrimage peaceful and stress-free."
    },
];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



      const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai to 5 Jyotirlinga Darshan Cab",
  "image": "https://skylinecabs.com/assets/images/navi-mumbai-to-5-jyotirlinga-cab.jpg",
  "description": "Book Navi Mumbai to 5 Jyotirlinga Darshan Cab with Skyline Cabs for a safe, comfortable, and spiritual Yatra. AC cabs available for one way and round trip, with professional drivers ensuring timely pickup and drop at all Jyotirlinga destinations in Maharashtra.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8043"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4999",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/navi-mumbai-to-5-jyotirlinga-darshan-cab"
  }
};




    return (
        <div>

<Helmet>
  <title>Navi Mumbai to 5 Jyotirlinga Darshan Cab | AC Yatra Cab | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Navi Mumbai to 5 Jyotirlinga Darshan Cab with Skyline Cabs for a safe and comfortable spiritual Yatra. AC cabs available for one way and round trip with professional drivers ensuring timely pickup and drop." 
  />
  <meta 
    name="keywords" 
    content="Navi Mumbai to 5 Jyotirlinga Darshan Cab, 5 Jyotirlinga Darshan Cab from Navi Mumbai, Navi Mumbai 5 Jyotirlinga Yatra Cab, 5 Jyotirlinga Tour Package Navi Mumbai by Cab, Navi Mumbai to Jyotirlinga Darshan Taxi, 5 Jyotirlinga Darshan Yatra Cab, Jyotirlinga Darshan Cab Service Navi Mumbai, Maharashtra 5 Jyotirlinga Darshan Cab, Jyotirlinga Tour Cab from Navi Mumbai, Lord Shiva Jyotirlinga Darshan Cab, AC Cab for 5 Jyotirlinga Darshan from Navi Mumbai, Round Trip Cab Navi Mumbai to Jyotirlinga, Private Cab for 5 Jyotirlinga Darshan, Skyline Cabs Navi Mumbai to 5 Jyotirlinga" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
    
      

      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/132.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Navimumbaitofivejyotilinga;